<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00037.installation.parametrage' | translate"
      [description]="'P00037.installation.parametrage.description' | translate"
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="'P00037.reglage.hivernage' | translate"
      [nameCustom]="'P00037.reglage.activationfct' | translate"
      [value]="actionStack!.getValue('elPActivationHivernage') !== 0"
      [information]="EnSavoirPlusPage"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.SALT_Parametrage1,
          'elPActivationHivernage',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (actionStack!.getValue('elPActivationHivernage') === 1) {
      <app-label-configuration
        [titleListe]="'P00037.reglage.seuilTemp' | translate"
        [value]="actionStack!.getValue('elPTemperatureHivernage')"
        [liste]="P00037TemperatureHivernage()"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.SALT_Parametrage1,
            'elPTemperatureHivernage',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    <app-label-description
      [description]="'P00037.reglage.hivernage.description' | translate"
    ></app-label-description>

    @if (showPositionModal()) {
      <app-information-title
        [title]="'P00037.parametre.sourcereference' | translate"
      ></app-information-title>

      <div class="my-3">
        <app-affichage-warning
          icon="fa-regular fa-exclamation-circle"
          [name]="'configuration.presentationmiseenservice.warning' | translate"
        ></app-affichage-warning>
      </div>

      <app-larged-link
        [name]="'P00037.configuration.sourceDebut' | translate"
        (onPress)="openPositionModal()"
      ></app-larged-link>

      <app-label-description
        [description]="
          'P00037.parametre.sourcereference.description' | translate
        "
      ></app-label-description>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
